export default __webpack_public_path__ + "static/media/ic-dl-lecture-videos.068ddf5f.svg";